module.exports = __webpack_public_path__ + "img/170.6d3fa73b.jpg";